import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-signal-strength',
  templateUrl: './signal-strength.component.html',
  styleUrls: ['./signal-strength.component.scss']
})
export class SignalStrengthComponent implements OnInit {

  @Input() signal: number;
  @Input() isMeasurement: boolean;
  public strength: number;

  constructor() { }

  ngOnInit() {
    this.strength = this.getSignalLevel();
  }

  public getSignalLevel() {

    this.signal = Math.abs(this.signal);

    if (this.signal > 119 && this.signal <= 105) {
      return 0;
    } else if (this.signal < 105 && this.signal >= 92) {
      return 1;
    } else if (this.signal < 92 && this.signal >= 78) {
      return 2;
    } else if (this.signal < 78 && this.signal >= 64) {
      return 3;
    } else if (this.signal <= 50) {
      return 4;
    }

    // if (this.signal > -114 && this.signal <= -107) {
    //   return 1;
    // } else if (this.signal > -107 && this.signal <= -100) {
    //   return 2;
    // } else if (this.signal > -100 && this.signal <= -93) {
    //   return 3;
    // } else if (this.signal >= -93) {
    //   return 4;
    // } else {
    //   return 0;
    // }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/signal-strength/signal-strength.component.ts